






























import Vue, { VueConstructor } from 'vue';
import JSONView from '../src/JSONView.vue';

export default Vue.extend({
  data: function() {
    return {
      events: [],
      dark: false
    };
  },
  components: { 'json-view': JSONView },
  methods: {
    itemSelected: function(data: any): void {
      // @ts-ignore
      this.events.push(`Selected: ${data.path} with value ${data.value}`);
    },
    toggleDark: function(): void {
      this.dark = !this.dark;
    }
  },
  computed: {
    data: function() {
      const test = {
        first: 'level',
        works: true,
        number: 100,
        missing: null,
        undefined: undefined,
        list: [
          'fun',
          {
            test: {
              passed: true
            }
          }
        ],
        object: {
          working: 'properly'
        }
      };
      return test;
    },
    colorScheme: function(): string {
      return this.dark ? 'dark' : 'light';
    }
  }
});
